// ** Initial State
const initialState = {
  // List
  data: [],
  total: 1,
  params: {},
  allData: [],

  notifySuccessInviteMember: null,
  notifyFailedInviteMember: null,
  notifySuccessResendInviteMember: null,
  notifyFailedResendInviteMember: null,
  notifySuccessDeleteInviteMember: null,
  notifyFailedDeleteInviteMember: null,
  notifySuccessDeleteMember: null,
  notifyFailedDeleteMember: null
}

const MemberReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_MEMBERS':
      return {
        ...state,
        allData: action.allData,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }      
    case 'SUCCESS_INVITE_MEMBER':
      return {
        ...state,
        notifySuccessInviteMember: true
      }     
    case 'FAILED_INVITE_MEMBER':      
      return {
        ...state,
        notifyFailedInviteMember: true
      }     
    case 'CLEAR_INVITE_MEMBER':      
      return {
        ...state,
        notifySuccessInviteMember: null,
        notifyFailedInviteMember: null
      }     
    case 'SUCCESS_RESEND_INVITE_MEMBER':
      return {
        ...state,
        notifySuccessResendInviteMember: true
      }     
    case 'FAILED_RESEND_INVITE_MEMBER':      
      return {
        ...state,
        notifyFailedResendInviteMember: true
      }     
    case 'CLEAR_RESEND_INVITE_MEMBER':      
      return {
        ...state,
        notifySuccessResendInviteMember: null,
        notifyFailedResendInviteMember: null
      }          
    case 'SUCCESS_DELETE_INVITE_MEMBER':
      return {
        ...state,
        notifySuccessDeleteInviteMember: true
      }     
    case 'FAILED_DELETE_INVITE_MEMBER':      
      return {
        ...state,
        notifyFailedDeleteInviteMember: true
      }     
    case 'CLEAR_DELETE_INVITE_MEMBER':      
      return {
        ...state,
        notifySuccessDeleteInviteMember: null,
        notifyFailedDeleteInviteMember: null
      }    

    case 'SUCCESS_DELETE_MEMBER':
      return {
        ...state,
        notifySuccessDeleteMember: true
      }     
    case 'FAILED_DELETE_MEMBER':      
      return {
        ...state,
        notifyFailedDeleteMember: true
      }     
    case 'CLEAR_DELETE_MEMBER':      
      return {
        ...state,
        notifySuccessDeleteMember: null,
        notifyFailedDeleteMember: null
      }    
    default:
      return state
  }
}

export default MemberReducer
